module.exports = __webpack_public_path__ + "img/百事合意_四方連續_線稿_black.59c21ecb.png";